import { render, staticRenderFns } from "./q-date.vue?vue&type=template&id=4643baf4&scoped=true&"
import script from "./q-date.vue?vue&type=script&lang=js&"
export * from "./q-date.vue?vue&type=script&lang=js&"
import style0 from "./q-date.vue?vue&type=style&index=0&id=4643baf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4643baf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yangxinyuan/vhall/vhall_questionnaire_service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4643baf4')) {
      api.createRecord('4643baf4', component.options)
    } else {
      api.reload('4643baf4', component.options)
    }
    module.hot.accept("./q-date.vue?vue&type=template&id=4643baf4&scoped=true&", function () {
      api.rerender('4643baf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/questionnaire/q-date.vue"
export default component.exports